module.exports = __webpack_public_path__ + "static/media/emissor-b-2.fa80c7a0.png";